// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import xOrderInformationStyles from "@conklin/App/SharedStyles/MyAccountPages/Details/OrderInformationStyles";
import { mergeWithCss } from "@conklin/XDL/Utilities";
import { requestedDateStyles } from "@insite/content-library/Widgets/OrderDetails/OrderDetailsRequestedDate";
import { css } from "styled-components";

requestedDateStyles.wrapper = {
    ...mergeWithCss(xOrderInformationStyles.headingAndTextStyles?.wrapper, {
        css: css`
            margin-bottom: 0;
        `,
    }),
};

requestedDateStyles.titleText = {
    ...xOrderInformationStyles.label,
};

requestedDateStyles.description = {
    ...xOrderInformationStyles.value,
};
